import { AIProvider, AIServiceOptions, AIServiceResponse, Message } from './types';

export abstract class BaseAIService {
  protected provider: AIProvider;
  
  constructor(provider: AIProvider) {
    this.provider = provider;
  }
  
  /**
   * 生成文本的主方法，所有提供商必须实现
   */
  abstract generateText(options: AIServiceOptions): Promise<AIServiceResponse>;
  
  /**
   * 将提示转换为消息数组
   */
  protected createMessages(prompt: string, systemPrompt?: string): Message[] {
    const messages: Message[] = [];
    
    if (systemPrompt) {
      messages.push({
        role: 'system',
        content: systemPrompt
      });
    }
    
    messages.push({
      role: 'user',
      content: prompt
    });
    
    return messages;
  }
  
  /**
   * 标准化错误处理
   */
  protected handleError(error: any): AIServiceResponse {
    console.error(`${this.provider} 提供商错误:`, error);
    
    return {
      text: '',
      error: error instanceof Error ? error.message : '发生未知错误'
    };
  }
} 